import { createSelector } from 'reselect';

const errorStatusCheck = () => state => state.get('errorStatusCheck');

const errorStatusCheckSelector = () =>
  createSelector(errorStatusCheck(), state => state.get('hasError'));

export { errorStatusCheckSelector };
